export class NetworkSyncV2 {
    networkId: string;
    toZiti: boolean;
}
